import { Box, Button, styled, Typography } from "@mui/material";
import colors from "../theme/colors";
import fonts from "../theme/fonts";
import { setGestureHelpLocalStorage } from "../util/localStorage";

interface GestureHelpProps {
  hideGestureHandler: Function;
}

export default function GestureHelp({ hideGestureHandler }: GestureHelpProps) {
  const neverShowHandler = () => {
    setGestureHelpLocalStorage(false);
    hideGestureHandler();
  };

  return (
    <Wrapper>
      <Box>
        <Title>Touch Gestures</Title>
      </Box>
      <RulesWrapper>
        <Box>Tap for x1</Box>
        <Box>Swipe left for x2</Box>
        <Box>Swipe right for x3</Box>
      </RulesWrapper>
      <Box display="flex" justifyContent="center">
        <Box flex="1">
          <BaseButton variant="contained" onClick={neverShowHandler}>
            Never Show Again
          </BaseButton>
        </Box>
        <Box flex="1">
          <OkButton variant="contained" onClick={() => hideGestureHandler()}>
            Hide
          </OkButton>
        </Box>
      </Box>
    </Wrapper>
  );
}

const Wrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  gap: "40px",
  fontFamily: fonts.family.nice,
  color: colors.lightBeige,
});

const Title = styled(Typography)({
  fontFamily: fonts.family.chalk,
  fontSize: fonts.size.large,
});

const RulesWrapper = styled(Box)({
  fontSize: fonts.size.mediumLarge,
  display: "flex",
  flexDirection: "column",
  gap: "10px",
});

const BaseButton = styled(Button)({
  textTransform: "none",
  backgroundColor: colors.lightRed,
});

const OkButton = styled(BaseButton)({
  backgroundColor: colors.lightBeige,
  color: colors.darkGray,
});
